import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-align: center;
  font-size: 25px;
  font-weight: 700;
  line-height: 32px;
`;

export const Terms = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: 13px;
  line-height: 20px;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing(3)} ${theme.spacing(0.5)}`};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  height: 248px;
  overflow: auto;
`;
